import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_ERGCHEBBI_MARRAKECH } from "@/lib/itineraryHubs";

export default function ErgChebbiMarrakechHubPage() {
  return <ItineraryHubPage hub={HUB_ERGCHEBBI_MARRAKECH} />;
}
